import {
    LINE,
    FACEBOOK,
    CONST
} from "@/utils/constants";

import {
    setAuthPage,
    getLocale
} from './storage'

export const PageRouter = {
    cargo_category: "cargo-category",
    customer_services: "customer-services",
    tukship_redpacket: 'redpacket',
    cargo_register: 'cargo-register',
    product: 'product',
    shopee_search: 'shopee-search',
    ali_product_url: 'aliproduct-url',
    order: 'order'
}

export function openWebPage(url) {
    window.open(url, "_self");
}

export function openWebPageBlank(url) {
    window.open(url, "_blank");
}

export function openWebPageLocale(dir, name, newTab) {
    const locale = getLocale()
    const url = `/${dir}/${name}-${locale}.html`
    if (newTab)
        openWebPageBlank(url)
    else
        openWebPage(url)
}

export function toLineLoginPage() {
    const redirectUrl = `${LINE.LOGIN_CALLBACK}`;
    const state = `beericher${Date.now()}`;
    const lineOAuthUtl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${LINE.CLIENT_ID}&redirect_uri=${redirectUrl}&state=${state}&scope=profile%20openid`;
    openWebPage(lineOAuthUtl)
}

export function toFacebookPage() {
    const redirectUrl = `${FACEBOOK.LOGIN_CALLBACK}`;
    const oAuthUtl = encodeURI(`https://www.facebook.com/dialog/oauth?client_id=${FACEBOOK.appId}&redirect_uri=${redirectUrl}&response_type=token`)
    openWebPage(oAuthUtl)
}

export function browserEnv() {
    const navi = window.navigator;
    const ua = navi.userAgent
    if (ua.includes('Line'))
        return CONST.LOGIN_TYPE.LINE

    if (ua.includes('FBAV') || ua.includes('FBIOS'))
        return CONST.LOGIN_TYPE.FACEBOOK

    if (ua.includes('FB'))
        return CONST.LOGIN_TYPE.FACEBOOK

    return CONST.LOGIN_TYPE.OTHER
}

export function toAuthorizationLogin(authPage) {
    if (authPage) {
        setAuthPage(authPage)
    }

    switch (browserEnv()) {
        case CONST.LOGIN_TYPE.LINE:
            toLineLoginPage();
            break;
        case CONST.LOGIN_TYPE.FACEBOOK:
            toFacebookPage();
            break;
        default:
            toLineLoginPage();
            break;
    }
}